import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import '../assets/Blog.css';

const BlogDetails = () => {



    const { slug } = useParams();

    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        setLoading(true);

        axios.get(`https://www.samriddhidevelopers.in/backend/getBlogBySlug.php?slug=${slug}`)
            .then(res => {
                if (res.data.blog) {
                    setBlog(res.data.blog); // ✅ FIXED
                } else {
                    setError("Blog not found");
                }
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setError("Something went wrong");
                setLoading(false);
            });

    }, [slug]);

    // ✅ Loading UI
    if (loading) {
        return <h2 style={{ padding: "40px", textAlign: "center" }}>Loading...</h2>;
    }

    // ✅ Error UI
    if (error) {
        return <h2 style={{ padding: "40px", textAlign: "center" }}>{error}</h2>;
    }

    // ✅ Safety check
    if (!blog) return null;

    const formattedDate = new Date(blog.created_at).toLocaleString("en-IN", {
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });

    return (
        <div className="blog-details">

            {/* ✅ SEO */}
            <Helmet>
                <title>{blog.meta_title || blog.title}</title>

                <meta
                    name="description"
                    content={blog.meta_description || blog.title}
                />

                <meta property="og:title" content={blog.meta_title || blog.title} />
                <meta property="og:description" content={blog.meta_description || blog.title} />
                <meta property="og:image" content={blog.image} />
                <meta property="og:url" content={`https://samriddhidevelopers.in/blog/${blog.slug}`} />
                <meta property="og:type" content="article" />

                {/* ✅ Schema */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BlogPosting",
                        "headline": blog.meta_title || blog.title,
                        "description": blog.meta_description || blog.title,
                        "image": blog.image,
                        "author": {
                            "@type": "Organization",
                            "name": "Samriddhi Group"
                        }
                    })}
                </script>
            </Helmet>

            {/* ✅ Blog Content */}
            <div className="blog-card">

                {/* HEADER */}
                <div className="blog-header">
                    <span className="blog-category">
                        Blog - By Samriddhi Group | Builder & Developers
                    </span>

                    <span className="blog-date">
                        Posted {formattedDate}
                    </span>
                </div>

                <h1 className="blog-title">{blog.title}</h1>

                <img src={blog.image} alt={blog.title} className="blog-image" />

                <div
                    className="blog-content"
                    dangerouslySetInnerHTML={{ __html: blog.content }}
                />

            </div>

        </div>
    );
};

export default BlogDetails;